import { render, staticRenderFns } from "./NovaConfirmModal.vue?vue&type=template&id=3050593e&lang=pug&"
import script from "./NovaConfirmModal.vue?vue&type=script&lang=js&"
export * from "./NovaConfirmModal.vue?vue&type=script&lang=js&"
import style0 from "./NovaConfirmModal.vue?vue&type=style&index=0&id=3050593e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports